
import React from "react";
import { useNavigate } from "react-router-dom";
import { VehicleIf } from "../../../types";


interface Props {
    data: VehicleIf[];
    isSlice?: boolean;
    start?: number;
    end?: number;
    page?: 'home' | 'vehicle';
}


const CartCard: React.FC<Props> = ({ data, isSlice, start = 0, end = 8, page = 'home' }) => {
    const navigate = useNavigate();
    console.log(data, isSlice, start, end, navigate);

    return (
        <>
            {(isSlice ? data?.slice(start, end) : data)?.map((item, index) => {
                return (
                    <div
                        key={index}
                        // className="bg-primaryColor rounded-xl hover:translate-y-[-10px] hover:shadow-md  ease-in-out transform transition-all duration-300 cursor-pointer aspect-square"
                        className={`${page === 'home' ? 'bg-primaryColor' : 'bg-[#ffffff]'} rounded-xl hover:translate-y-[-10px] hover:shadow-md  ease-in-out transform transition-all duration-300 cursor-pointer aspect-square`}
                        //  data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200"
                        data-aos="fade-up"
                        data-aos-duration={index * 1200}
                        data-aos-delay={index * 200}
                    >
                        <div
                            className={`flex flex-col justify-between items-stretch space-y-3 h-full ${page === 'home' ? 'text-white' : 'text-black'}`}
                            onClick={() => navigate(`/vehicle/${item.category_id}`)}
                        >
                            <div className="pt-4 px-4 space-y-2">
                                <div className='flex items-center justify-between'>
                                    <h1 className='text-[20px] font-semibold'>{item.category_name}</h1>
                                </div>
                                <div className="flex items-center justify-start gap-2">
                                    <div className={`flex items-center text-xs bg-opacity-20 rounded-2xl px-2 py-1 ${page === 'home' ? 'bg-[#ffffff]' : 'bg-[#1a1a1a1a]'}`}>
                                        <i className="fas fa-user"></i>
                                        <span className='ml-2'>{item.max_occupants}</span>
                                    </div>
                                    <div className={`flex items-center text-xs bg-opacity-20 rounded-2xl px-2 py-1 ${page === 'home' ? 'bg-[#ffffff]' : 'bg-[#1a1a1a1a]'}`}>
                                        <i className="fas fa-suitcase"></i>
                                        <span className='ml-2'>{item.max_luggage}</span>
                                    </div>
                                </div>
                            </div>
                            <img
                                src={
                                    item?.category_name === 'SUV' ? "assets/images/other/Compact SUV.png"
                                        : item?.category_name === "Cars" ? "assets/images/other/Standard.png"
                                            : item?.category_name === "Minivan" ? "assets/images/other/Minivan.png"
                                                : 'assets/images/other/Standard.png'
                                }
                                alt='car'
                                className='w-full h-full object-scale-down md:h-[100px]'
                            />
                            <div className='flex items-center justify-between pb-4 px-4'>
                                <div className='text-[18px] font-semibold'>
                                    <span> {
                                        item.price.toLocaleString('en-US', {
                                            style: 'currency',
                                            currency: 'LKR',
                                        })
                                    }/</span>
                                    <span className='ml-2 text-[14px] font-semibold'>day</span>
                                </div>
                            </div>
                        </div>
                    </div >
                );
            })}
        </>
    );
}

export default CartCard;